module.exports = __webpack_public_path__ + "static/media/view_icon.16a9ad82.svg";